import { createApiSlice } from "@common/common-slice/commonSlice";

// routes
import {
  CRUD_EVALUATION_CRITERIA,
  TALENAISE_GENERATE,
  GET_EVALUATION_CRITERIA,
  GET_EVALUATION_CRITERIA_DETAILS,
  STORE_EVALUATION_CRITERIA,
} from "@routes";

const apiConfig = [
  {
    name: "createEvaluationCriteria",
    method: "post",
    url: CRUD_EVALUATION_CRITERIA,
    stateKey: "message",
  },
  {
    name: "getEvaluationCriteria",
    method: "get",
    url: GET_EVALUATION_CRITERIA,
    stateKey: "data",
  },
  {
    name: "getEvaluationCriteriaDetails",
    method: "get",
    url: GET_EVALUATION_CRITERIA_DETAILS,
    stateKey: "detailsData",
  },
  {
    name: "generateEvaluationCriteria",
    method: "post",
    url: TALENAISE_GENERATE,
    stateKey: "generatedData",
    loadingKey: "genLoading",
  },
  {
    name: "storeGenerateEvaluationCriteria",
    method: "post",
    url: STORE_EVALUATION_CRITERIA,
    stateKey: "message",
    loadingKey: "genLoading",
  },
  {
    name: "updateEvaluationCriteria",
    method: "put",
    url: CRUD_EVALUATION_CRITERIA,
    stateKey: "message",
  },
  {
    name: "deleteEvaluationCriteria",
    method: "delete",
    url: CRUD_EVALUATION_CRITERIA,
    stateKey: "message",
  },
];

// ---------------------------------------------------------------------

const customReducers = {
  initialState: {
    detailsData: [],
    generatedData: [],
    selectedEvaluationCriteriaData: {},
    generate: false,
    genLoading: false,
  },

  reducers: {
  },

  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "evaluationCriteria",
  apiConfig,
  customReducers,
);

const evaluationCriteriaSlice = slice;

export default evaluationCriteriaSlice.reducer;

export const {
  createEvaluationCriteria,
  getEvaluationCriteria,
  getEvaluationCriteriaDetails,
  generateEvaluationCriteria,
  storeGenerateEvaluationCriteria,
  updateEvaluationCriteria,
  deleteEvaluationCriteria,
} = thunks;

export const {
  rowSelect,
} = actions;